import React, { useState, useEffect } from 'react';
import { toast } from 'react-hot-toast';
import { FiPlus, FiTrash2, FiEdit2 } from 'react-icons/fi';
import { Link } from 'react-router-dom';

const defaultJobs = [
    { id: 1, title: 'Cleaning Supervisor', location: 'Manama, Bahrain', type: 'Full-time' },
    { id: 2, title: 'Cleaner', location: 'Manama, Bahrain', type: 'Full-time' },
    { id: 3, title: 'Rope Access Technician – Level 1', location: 'Manama, Bahrain', type: 'Full-time' },
];

const ManageCareers = () => {
    const [jobs, setJobs] = useState([]);
    const [isLoading, setIsLoading] = useState(true);

    const fetchJobs = async () => {
        try {
            const response = await fetch('/api/careers/read.php');
            if (response.ok) {
                const contentType = response.headers.get("content-type");
                if (contentType && contentType.includes("application/json")) {
                    const data = await response.json();
                    if (data.records && data.records.length > 0) {
                        setJobs(data.records);
                    } else {
                        setJobs(defaultJobs);
                    }
                } else {
                    setJobs(defaultJobs);
                }
            } else {
                setJobs(defaultJobs);
            }
        } catch (error) {
            console.error('Fetch error:', error);
            setJobs(defaultJobs);
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        fetchJobs();
    }, []);

    const handleDelete = async (id) => {
        if (!window.confirm('Are you sure you want to delete this job?')) return;

        try {
            const response = await fetch('/api/careers/delete.php', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ id }),
            });

            if (response.ok) {
                toast.success('Job deleted successfully');
                fetchJobs();
            } else {
                toast.error('Failed to delete job');
            }
        } catch (error) {
            console.error('Delete error:', error);
            toast.error('Failed to connect to server');
        }
    };

    return (
        <div>
            <div className="flex items-center justify-between mb-8">
                <div>
                    <h1 className="text-2xl font-bold text-gray-800">Manage Careers</h1>
                    <p className="text-gray-500">Post new job openings and manage applications</p>
                </div>
                <Link to="/admin/careers/create" className="flex items-center gap-2 bg-primary-600 text-white px-5 py-2.5 rounded-lg hover:bg-primary-700 transition-colors font-medium">
                    <FiPlus />
                    <span>Post Job</span>
                </Link>
            </div>

            <div className="bg-white rounded-xl shadow-sm overflow-hidden">
                <div className="overflow-x-auto">
                    <table className="w-full text-left">
                        <thead>
                            <tr className="bg-gray-50 border-b border-gray-100">
                                <th className="p-4 font-semibold text-gray-600">Job Title</th>
                                <th className="p-4 font-semibold text-gray-600">Location</th>
                                <th className="p-4 font-semibold text-gray-600">Type</th>
                                <th className="p-4 font-semibold text-gray-600 text-right">Actions</th>
                            </tr>
                        </thead>
                        <tbody className="divide-y divide-gray-100">
                            {isLoading ? (
                                <tr>
                                    <td colSpan="4" className="p-8 text-center text-gray-500">Loading...</td>
                                </tr>
                            ) : jobs.length === 0 ? (
                                <tr>
                                    <td colSpan="4" className="p-8 text-center text-gray-500">No jobs posted.</td>
                                </tr>
                            ) : (
                                jobs.map((job) => (
                                    <tr key={job.id} className="hover:bg-gray-50 transition-colors">
                                        <td className="p-4 font-medium text-gray-800">{job.title}</td>
                                        <td className="p-4 text-gray-600">{job.location}</td>
                                        <td className="p-4 text-gray-500 text-sm">
                                            <span className="px-2 py-1 bg-blue-50 text-blue-600 rounded text-xs font-semibold">{job.type}</span>
                                        </td>
                                        <td className="p-4 text-right">
                                            <div className="flex items-center justify-end gap-2">
                                                <Link to={`/admin/careers/edit/${job.id}`} className="p-2 text-blue-500 hover:bg-blue-50 rounded-lg transition-colors" title="Edit">
                                                    <FiEdit2 />
                                                </Link>
                                                <button
                                                    onClick={() => handleDelete(job.id)}
                                                    className="p-2 text-red-500 hover:bg-red-50 rounded-lg transition-colors"
                                                    title="Delete"
                                                >
                                                    <FiTrash2 />
                                                </button>
                                            </div>
                                        </td>
                                    </tr>
                                ))
                            )}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    );
};

export default ManageCareers;
